import Api from "../../service";

async function getState (state){
    return await Api.get('/api/v1/getStateOptions/'+state);
}
export default getState;